export default {
  state: {
    updatesSearchResults: [
      {
        title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
        date: `${new Date().getDate()}/${
          new Date().getMonth() + 1
        }/${new Date().getFullYear()}`,
        content:
          'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      },
      {
        title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
        date: `${new Date().getDate()}/${
          new Date().getMonth() + 1
        }/${new Date().getFullYear()}`,
        content:
          'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      },
      {
        title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
        date: `${new Date().getDate()}/${
          new Date().getMonth() + 1
        }/${new Date().getFullYear()}`,
        content:
          'Lorem ipsum dolor sit amet,<span class="markYellow">consectetur adipiscing elit</span>, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,<span class="markOrange">quis nostrud exercitation</span> ullamco laboris nisi ut aliquip ex ea commodo consequat. <span class="markOrange">Duis aute irure dolor in reprehenderit </span> in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      },
    ],
  },
  mutations: {},
  getters: {
    GET_UPDATES_SEARCH_RESULTS(state) {
      return state.updatesSearchResults
    },
  },
}
